import ApiService from "../../services/ApiService";
import Logger from "../../services/Logger";

const BASE = "/v1/puzzle/jigsaw/pack";

function failureMessage(response, fallback) {
    if (response?.code === "FAILURE" || response?.code === "NO_DATA") {
        return response.message || fallback;
    }
    return null;
}

const AdminJigsawPackService = {
    list: async () => {
        try {
            const response = await ApiService.getData(BASE);
            const error = failureMessage(response, "Failed to load packs");
            if (error) return { success: false, error };
            const rows = Array.isArray(response) ? response : response?.content ?? [];
            return { success: true, data: rows };
        } catch (e) {
            Logger.error("AdminJigsawPackService.list:", e);
            return { success: false, error: e.message };
        }
    },

    get: async (id) => {
        try {
            const response = await ApiService.getData(`${BASE}/${encodeURIComponent(id)}`);
            const error = failureMessage(response, "Failed to load pack");
            if (error) return { success: false, error };
            return { success: true, data: response };
        } catch (e) {
            Logger.error("AdminJigsawPackService.get:", e);
            return { success: false, error: e.message };
        }
    },

    create: async (body) => {
        try {
            const response = await ApiService.postData(BASE, body);
            const error = failureMessage(response, "Failed to create pack");
            if (error) return { success: false, error };
            return { success: true, data: response };
        } catch (e) {
            Logger.error("AdminJigsawPackService.create:", e);
            return { success: false, error: e.message };
        }
    },

    update: async (id, body) => {
        try {
            const response = await ApiService.putData(`${BASE}/${encodeURIComponent(id)}`, body);
            const error = failureMessage(response, "Failed to update pack");
            if (error) return { success: false, error };
            return { success: true, data: response };
        } catch (e) {
            Logger.error("AdminJigsawPackService.update:", e);
            return { success: false, error: e.message };
        }
    },

    remove: async (id) => {
        try {
            const response = await ApiService.deleteData(`${BASE}/${encodeURIComponent(id)}`);
            const error = failureMessage(response, "Failed to delete pack");
            if (error) return { success: false, error };
            return { success: true, data: response };
        } catch (e) {
            Logger.error("AdminJigsawPackService.remove:", e);
            return { success: false, error: e.message };
        }
    },

    suggestPictures: async (id, body) => {
        try {
            const response = await ApiService.postData(`${BASE}/${encodeURIComponent(id)}/suggest-pictures`, body || {});
            const error = failureMessage(response, "Could not suggest pictures");
            if (error) return { success: false, error };
            const pictures = response?.pictures || response?.data?.pictures || [];
            return { success: true, data: pictures };
        } catch (e) {
            Logger.error("AdminJigsawPackService.suggestPictures:", e);
            return { success: false, error: e.message };
        }
    },

    suggestTitle: async (id) => {
        try {
            const response = await ApiService.postData(`${BASE}/${encodeURIComponent(id)}/suggest-title`, {});
            const error = failureMessage(response, "Could not suggest a title");
            if (error) return { success: false, error };
            const title = response?.title || response?.data?.title || "";
            if (!title) return { success: false, error: "Could not suggest a title" };
            return { success: true, data: title };
        } catch (e) {
            Logger.error("AdminJigsawPackService.suggestTitle:", e);
            return { success: false, error: e.message };
        }
    },
};

export default AdminJigsawPackService;
